export enum TaskStatusesEnum {

  TODO = 'To Do',
  IN_PROGRESS = 'In Progress',
  REVIEW = 'Review',
  DONE = 'Done',
  HOLD = 'Hold'

}
